import React from 'react';
import clsx from 'clsx';
import Skeleton from '@smart-tv/components/skeleton';
import styles from './stripe-skeleton.module.scss';

const ITEM_COUNT = (isPortrait: boolean) => (isPortrait ? 7 : 5);

interface Props {
  isPortrait?: boolean;
}

// Shown in place of the stripe rows while fetchGenres() is updating the universe/program-type
// filter - a single row placeholder, unlike the full-page StripesSkeleton used on initial load.
export const StripeSkeleton: React.FC<Props> = ({ isPortrait = false }) => {
  const elements = [...Array(ITEM_COUNT(isPortrait))];

  return (
    <div className={styles['stripe-skeleton']}>
      {elements.map((_, index) => (
        <Skeleton
          key={index}
          variant="rect"
          animation="wave"
          className={clsx(
            styles['stripe-skeleton__item'],
            isPortrait ? styles['stripe-skeleton__item--portrait'] : styles['stripe-skeleton__item--landscape']
          )}
        />
      ))}
    </div>
  );
};

export default StripeSkeleton;
